export default __webpack_public_path__ + "static/media/lpf_junior.d47b2319.svg";